// RDS
import Icon from '@ramsey-design-system/icon';
import { ChevronLeftIcon, ChevronRightIcon } from '@ramsey-design-system/icons';
import Text from '@ramsey-design-system/text';

function NoResponsesMessage({ message }: { message?: string }) {
  return (
    <div className="relative mb-3">
      <div className="flex flex-row">
        <Icon
          icon={ChevronLeftIcon}
          className="text-gray-20 mr-3"
          size="large"
        />
        <section>
          <div className="mb-1.5">
            <div className="bg-gray-20 h-4 w-full max-w-[182px] opacity-25" />
            <div className="text-1 text-gray-20">This is temporary.</div>
          </div>
          <div className="mb-1.5">
            <div className="bg-gray-20 h-4 w-full max-w-[66px] opacity-25" />
            <div className="text-1 text-gray-20">
              I&apos;ve made it through worst.
            </div>
          </div>
          <div className="mb-1.5">
            <div className="bg-gray-20 h-4 w-full max-w-[130px] opacity-25" />
            <div className="text-1 text-gray-20">
              I&apos;m learning and growing.
            </div>
          </div>
          <div className="bg-gray-20 h-4 w-full max-w-[372px] opacity-25" />
          <div className="text-1 text-gray-20">
            It is what it is. I&apos;m trying my best.
          </div>
        </section>
        <Icon
          icon={ChevronRightIcon}
          className="text-gray-20 ml-auto"
          size="large"
        />
      </div>

      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <Text className="mb-2 font-semibold text-gray-50">
          No responses yet.
        </Text>
        {message ? (
          <Text className="text-center font-semibold text-gray-50">
            {message}
          </Text>
        ) : (
          <Text className="text-center font-semibold text-gray-50">
            Scan the QR code below to submit your answer!
          </Text>
        )}
      </div>
    </div>
  );
}
export default NoResponsesMessage;
